<template>
  <div class="nav-container">
    <div class="logo-header">
      <a href="./statistieken">
        <div class="logo" />
      </a>
    </div>

    <div v-bind:class="{ show: isExpanded }">
      <div class="menu-buttons">
          <Slide right class="burger-menu">
              <router-link :to="{ name: 'StatisticsOverview' }" v-if="isLoggedIn">
                  <q-btn outline
                         color="primary"
                         label="Statistieken"
                         class="burgermenu-button">
                  </q-btn>
              </router-link>

              <router-link :to="{ name: 'UploadDocument' }" v-if="isLoggedIn && hasPermission && !isFomoViewer">
                  <q-btn outline
                         color="primary"
                         label="Document uploaden"
                         class="burgermenu-button">
                  </q-btn>
              </router-link>

              <router-link :to="{ name: 'FilesOverview' }" v-if="isLoggedIn && !isFomoViewer">
                  <q-btn outline
                         color="primary"
                         label="Alle uploads"
                         class="burgermenu-button">
                  </q-btn>
              </router-link>

              <router-link :to="{ name: 'UserProfile', params: { tab: 'myBasicDetails' } }"
                           v-if="isLoggedIn">
                  <q-btn outline
                         color="primary"
                         label="Profile"
                         class="burgermenu-button">
                  </q-btn>
              </router-link>
          </Slide>

        <div class="largescreen-buttons">
          <div class="all-menu-buttons">
              <div class="leftmenu-buttons">
                  <router-link :to="{ name: 'StatisticsOverview' }" class="navmenu-link">
                      <q-btn flat
                             no-caps
                             color="white"
                             v-if="isLoggedIn"
                             label="Statistieken"
                             class="navmenu-link q-ml-sm bold-text">
                      </q-btn>
                  </router-link>
                  <router-link :to="{ name: 'UploadDocument' }" class="navmenu-link" v-if="hasPermission && !isFomoViewer">
                      <q-btn flat
                             color="white"
                             label="Document uploaden"
                             no-caps
                             v-if="isLoggedIn"
                             class="navmenu-link q-ml-sm bold-text">
                      </q-btn>
                  </router-link>
                  <router-link :to="{ name: 'FilesOverview' }" class="navmenu-link" v-if="!isFomoViewer">
                      <q-btn flat
                             color="white"
                             label="Alle uploads"
                             no-caps
                             v-if="isLoggedIn"
                             class="navmenu-link q-ml-sm bold-text">
                      </q-btn>
                  </router-link>
              </div>
            <div class="right-menu-buttons">
              <q-btn-dropdown
                flat
                color="white"
                v-if="isLoggedIn"
                icon="account_circle"
                class="navmenu-link"
                id="v-step-13"
              >
                <q-list>
                  <!--<router-link
                    :to="{
                      name: 'UserProfile',
                      params: { tab: 'myBasicDetails' },
                    }"
                    class="navmenu-link"
                    style="text-decoration: none"
                  >
                    <q-item clickable v-close-popup>
                      <q-item-section> Mijn gegevens </q-item-section>
                    </q-item>
                  </router-link>-->

                  <router-link
                    v-if="hasPermission && !isFomoViewer"
                    :to="{
                      name: 'UploadDocument',                      
                    }"
                    class="navmenu-link"
                    style="text-decoration: none"
                  >
                    <q-item clickable v-close-popup>
                      <q-item-section> Document uploaden</q-item-section>
                    </q-item>
                  </router-link>

                  <router-link
                    v-if="!isFomoViewer"
                    :to="{
                      name: 'FilesOverview',                      
                    }"
                    class="navmenu-link"
                    style="text-decoration: none"
                  >
                    <q-item clickable v-close-popup>
                        <q-item-section> Alle uploads</q-item-section>
                    </q-item>
                  </router-link>

                  <router-link
                    flat
                    color="white"
                    :to="{ name: 'Login' }"
                    class="navmenu-link"
                    style="text-decoration: none"
                  >
                    <q-item clickable v-close-popup>
                      <q-item-section @click="logout">
                        Uitloggen
                      </q-item-section>
                    </q-item>
                  </router-link>
                </q-list>
              </q-btn-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store/index.js';
import { Slide } from 'vue3-burger-menu';
import { computed, ref } from 'vue';
import authService from '../services/auth.service.js';
import router from '../router/index.js';

export default {
  name: 'NavMenu',
  components: {
    Slide,
  },
  setup() {
    const logout = async () => {
      await authService.logout(true);
      router.push({
        name: 'Login',
      });
    };

    const collapse = () => {
      this.isExpanded = false;
    };

    const toggle = () => {
      this.isExpanded = !this.isExpanded;
    };

    const isLoggedIn = computed({
      get: () => store.state.auth.isLoggedIn,
    });

    // replace with authUser, add hasFomoManagementPermission to authUSer
    const hasPermission = computed({
        get: () => store.state.auth.authUser.hasFomoManagementPermission
    });

    const showAdminPanel = computed({
      get: () => store.state.auth.authUser.showAdminPanel,
    });

    const isExpanded = ref(false);

    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });

    const resultCount = computed({
      get: () => store.state.newsSearch.resultsCount,
    });

    const displayNumberOfNewsResults = computed({
      get: () => store.state.advancedSearch.displayNumberOfNewsResults,
    });

    
    const isFomoViewer = computed({
      get: () => store.state.auth.authUser.isFomoViewer,
    });
    return {
      displayNumberOfNewsResults,
      resultCount,
      logout,
      isLoggedIn,
      collapse,
      toggle,
      isExpanded,
      showAdminPanel,
      isVind,
      hasPermission,
      isFomoViewer
    };
  },
};
</script>
